module.exports = __webpack_public_path__ + "static/media/snappy-tool.2ae72df2.svg";